import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar';
import axios from "./axios.js"

import common_js from "./assets/js/common.js";
import alert_js from "./assets/js/alert.js";
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false;
Vue.prototype.$http = axios

Vue.use(common_js);
Vue.use(alert_js);
Vue.use(VueCookies, { expires: '1Y' });
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.prototype.$EventBus = new Vue();


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
